import React, { useState } from "react";
import PropTypes from "prop-types";

import { useApolloClient } from "react-apollo";
import gql from "graphql-tag";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Button, Icon } from "rbx";

import { REFRESH_ORDER_MUTATION } from "../graphql/Orders/Orders.graphql";

const GET_ORDER_NUMBERS = gql`
  query Orders($where: OrderWhereInput) {
    Orders(
      where: $where
      orderByMulti: [
        PickupDriverRecIdRef_ASC
        PickupLoc_SI_ASC
        PickupDate_ASC
        OrderNumber_ASC
      ]
    ) {
      RecId
      OrderNumber
    }
  }
`;

const { REACT_APP_REPORT_BASE_URL = "https://gdev.gravoc.com" } = process.env;

const PrintBOL = ({ filters, handleSave, edited }) => {
  const client = useApolloClient();
  const [loading, setLoading] = useState(false);

  const goToHref = async where => {
    try {
      setLoading(true);

      if (handleSave && edited) {
        await handleSave(null, true);
      }
      const { data } = await client.query({
        query: GET_ORDER_NUMBERS,
        variables: { where }
      });

      if (data && data.Orders) {
        await Promise.all(
          data.Orders.map(o =>
            client.mutate({
              mutation: REFRESH_ORDER_MUTATION,
              variables: {
                where: {
                  RecId: o.RecId
                }
              }
            })
          )
        );
        window.open(
          `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=BOL&Param=BOLNumber&ParamValue=${data.Orders.map(
            o => `${o.OrderNumber}`
          ).join(",")}`
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      color="link"
      disabled={loading}
      size="small"
      state={loading ? "loading" : ""}
      onClick={() => goToHref(filters)}
    >
      <Icon>
        <FontAwesomeIcon icon="print" />
      </Icon>
      <span>Print BOL</span>
    </Button>
  );
};

PrintBOL.propTypes = {
  filters: PropTypes.object,
  handleSave: PropTypes.func,
  edited: PropTypes.bool
};
PrintBOL.defaultProps = {
  filters: {},
  handleSave: () => null,
  edited: false
};
export default PrintBOL;
